import React, { createContext, useState, useEffect } from "react";
import { GetMasterDataByTypeNames } from "../Services/MasterDataService";
import { getDataLocal } from "../Helper/localStoreFunction";
import { LocalStoreType } from "../constants/local-type";
import _ from "lodash";

type IMasterSettingContextType = {
  masterSetting: { [key: string]: any };
  updateMasterData: (masterData: any[]) => void;
  getMasterSetting: () => Promise<{ [key: string]: any }>;
};

export const MasterSettingContext =
  createContext<IMasterSettingContextType | null>(null);

export const MasterSettingContextProvider: React.FC = (props) => {
  const [masterSetting, setMaterSetting] = useState<{ [key: string]: any }>({});
  const listMasterType = [
    "FormatDate",
    "RefSpec",
    "splitPage",
    "ComConfig",
    "form_limit",
    "reportSummary",
    "commentLim",
    "exceptHide",
    "requiredTo"
  ];

  const fecthData = async () => {
    let settingDict = await getMasterSetting();
    setMaterSetting(settingDict);
  };

  useEffect(() => {
    if (!getDataLocal(LocalStoreType.userData)) return;
    fecthData();
  }, [getDataLocal(LocalStoreType.userData)]);

  const updateMasterData = (masterData: any[]) => {
    if (masterData.length > 0) {
      const lowerCaseTypes = listMasterType.map((type) => type?.toLowerCase());
  
      const _masterData = masterData.filter(
        (e) =>
          e.IsActive &&
          lowerCaseTypes.includes((e.MasterType || "").toLowerCase())
      );
  
      let settingDict: any = {};
      _masterData.forEach((e: any) => {
        settingDict[e.MasterType.toLowerCase()] = e;
      });
  
      setMaterSetting(settingDict);
    }
  };

  const getMasterSetting = async () => {
    const masterData = await GetMasterDataByTypeNames(listMasterType)
      .then((e) => e.filter((e: any) => e.IsActive))
      .catch((err) => {
        console.error(err);
      });

    let settingDict: any = {};
    masterData?.forEach((e: any) => {
      settingDict[e.MasterType] = e;
    });

    return settingDict;
  };

  return (
    <MasterSettingContext.Provider
      value={{ masterSetting, updateMasterData, getMasterSetting }}
    >
      {props.children}
    </MasterSettingContext.Provider>
  );
};
